import { Typography } from '@statsbomb/kitbag-components';
import { useAtomValue } from 'jotai';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { teamGameEventDescriptionsAtom } from '@/atoms/queries/team/teamEventData';
import { teamIdAtom } from '@/atoms/team/team';
import { VideoPlayer } from '@/components/video/VideoPlayer';
import { useFormatVideoEvents } from '@/hooks/useFormatVideoEvents';
import { useSetMetricKey } from '@/hooks/useMetricKey';
import { useRightPanelHeader } from '@/hooks/useRightPanelHeader/useRightPanelHeader';
import { useSetGameIdForVideos } from '@/hooks/useSetGameIdForVideos';
import { useSetIdAtom } from '@/hooks/useSetIdAtom';
import { useUpdateQueryString } from '@/hooks/useUpdateQueryString';
import { useVideoDataForEvents } from '@/hooks/useVideoDataForEvents';

const TeamGamesVideoPlayerWithData = () => {
  const teamGameEventDescriptions = useAtomValue(teamGameEventDescriptionsAtom);
  const { videoIds, unavailableVideosCount, ref } = useVideoDataForEvents<HTMLSpanElement>(teamGameEventDescriptions);
  const videoEvents = useFormatVideoEvents(videoIds, teamGameEventDescriptions);

  return (
    <span ref={ref}>
      <VideoPlayer videoEvents={videoEvents} unavailableVideosCount={unavailableVideosCount} />
    </span>
  );
};

const TeamGamesVideoPlayer = () => {
  const { t } = useTranslation('video');

  return (
    <Suspense
      fallback={
        <Typography variant="bodyMedium" className="p-4">
          {t('loadingVideo')}
        </Typography>
      }
    >
      <div className="p-4">
        <TeamGamesVideoPlayerWithData />
      </div>
    </Suspense>
  );
};

export const TeamGamesVideoPreview = () => {
  useSetMetricKey();
  useSetIdAtom(teamIdAtom, 'teamId');
  useSetGameIdForVideos();

  const { t } = useTranslation('video');
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const updateQueryString = useUpdateQueryString(searchParams);

  useRightPanelHeader(t('player'), () => navigate(`..?${updateQueryString([], undefined)}`));

  return <TeamGamesVideoPlayer />;
};
